import z from "zod"

export const ThemeTypeEnum = z.enum(["dark", "light"])

export const ThemeSourceTypeEnum = z.enum(["QueryString", "AppStore", "System"])

export const AppStoreThemeSchema = z
  .union([
    z.literal(ThemeTypeEnum.enum.dark),
    z.literal(ThemeTypeEnum.enum.light),
    z.literal(""),
  ])
  .default("")

export const QueryStringThemeSchema = z
  .union([
    z.literal(ThemeTypeEnum.enum.dark),
    z.literal(ThemeTypeEnum.enum.light),
  ])
  .nullable()

export const SystemThemeSchema = z.union([
  z.literal(ThemeTypeEnum.enum.dark),
  z.literal(ThemeTypeEnum.enum.light),
])

/** @typedef {z.infer<typeof ThemeTypeEnum>} ThemeType */
/** @typedef {z.infer<typeof ThemeSourceTypeEnum>} ThemeSourceType */
/** @typedef {z.infer<typeof AppStoreThemeSchema>} AppStoreTheme */
/** @typedef {z.infer<typeof QueryStringThemeSchema>} QueryStringTheme */
/** @typedef {z.infer<typeof SystemThemeSchema>} SystemTheme */
